<header class="dialog-title">{{ 'driver.history' | translate }}</header>

<div class="driver">
  <div class="avatar">
    <img [src]="currentDriver.avatarUrl" alt="avatar">
  </div>

  <span>{{ currentDriver.getFullName() }}</span>
</div>

<div class="filters-box">
  <app-checkbox-list-filter [name]="'term.units' | translate"
    [itemList]="unitList"
    (filterChange)="unitListFilterChange($event)">
  </app-checkbox-list-filter>

  <app-date-range-filter [timeZone]="timeZone"
    [name]="'term.time' | translate"
    (filterChange)="dateRangeFilterChange($event)">
  </app-date-range-filter>
</div>


@if (history().length > 0) {
  <div class="box-table">
    <app-driver-history-table
      [history]="history()"
      [pagination]="pagination.tableState()"
      [timeZone]="timeZone"
      (pageChange)="onChangePage($event)"
      (sortChange)="onSortData($event)">
    </app-driver-history-table>
  </div>
}

@if (history().length === 0) {
  <div class="container-message">
    {{ 'message.error.nothing-found' | translate }}
  </div>
}

<div class="app-dialog-actions">
  <app-button-back (action)="onReturn()"></app-button-back>
</div>
